import { useEffect, useState } from "react";
import { Compass } from "lucide-react";

const STEPS = [
  "Analyse du rayon local autour de votre ville…",
  "Sélection de zones cohérentes, sans zigzag…",
  "Recherche d'hébergements bien notés…",
  "Assemblage activités et restauration dans la même zone…",
  "Comparaison train vs voiture…",
  "Vérification du budget pour votre groupe…",
];

export const GeneratingState = ({ city }) => {
  const [i, setI] = useState(0);
  useEffect(() => {
    const t = setInterval(() => setI((x) => Math.min(x + 1, STEPS.length - 1)), 9000);
    return () => clearInterval(t);
  }, []);
  return (
    <div data-testid="search-loading-state" className="rounded-2xl bg-[#15202B]/80 backdrop-blur-xl border border-white/10 p-8 sm:p-10 text-white">
      <div className="flex items-center gap-4">
        <Compass className="w-8 h-8 text-amber-500 animate-spin" style={{ animationDuration: "4s" }} />
        <div>
          <p className="font-serif text-2xl">Nous composons vos escapades depuis {city}</p>
          <p className="text-sm text-gray-400 mt-1">Cela prend généralement 30 à 60 secondes.</p>
        </div>
      </div>
      <ul className="mt-8 space-y-3">
        {STEPS.map((s, idx) => (
          <li key={s} className={`flex items-center gap-3 text-sm transition-opacity duration-500 ${idx <= i ? "opacity-100" : "opacity-30"}`}>
            <span className={`w-2 h-2 rounded-full ${idx < i ? "bg-emerald-500" : idx === i ? "bg-amber-500 pulse-dot" : "bg-gray-600"}`} />
            {s}
          </li>
        ))}
      </ul>
    </div>
  );
};
